import { Button } from "@/components/ui/button";
import { Eye, Palette } from "lucide-react";
import { ProfileActionsProps } from "../types";

export const ProfileActions = ({ 
  isOwnProfile, 
  isVisitorView, 
  setIsVisitorView, 
  setShowEditDialog,
  onCustomizeBackground 
}: ProfileActionsProps & { onCustomizeBackground?: () => void }) => {
  if (!isOwnProfile) return null;

  return (
    <div className="flex gap-2">
      {!isVisitorView && (
        <>
          <Button 
            variant="outline"
            onClick={() => setShowEditDialog(true)}
          >
            Edit Profile
          </Button>
          <Button variant="outline">Share Profile</Button>
          <Button 
            variant="outline" 
            size="sm"
            className="flex items-center gap-2"
            onClick={onCustomizeBackground}
          >
            <Palette className="h-4 w-4" />
            Customize Background
          </Button>
        </>
      )}
      <Button
        variant="outline"
        size="sm"
        className="gap-2"
        onClick={() => setIsVisitorView(!isVisitorView)}
      >
        <Eye className="h-4 w-4" />
        {isVisitorView ? "Exit Visitor View" : "View as Visitor"}
      </Button>
    </div>
  );
};